import React, { useState, useEffect, useContext } from "react";
import Modal from "react-bootstrap/Modal";
import { API_URL } from "../../components/api";
import { formatDateTime } from "../../../utils/dateFormat";
import PrintInvoice from "./PrintInvoice";
import EditInvoice from "./EditInvoice";
import {
  DataGrid,
  GridToolbarContainer,
  GridToolbarColumnsButton,
  GridToolbarFilterButton,
  GridToolbarExport,
} from "@mui/x-data-grid";
import ExcelSVG from "./ExcelSVG.svg";
import FilterSVG from "./FilterSVG.svg";
import * as XLSX from "xlsx";
import Button from "@mui/material/Button";

import AuthContext from "../../context/AuthContext";

// For API Requests
import axios from "axios";

function InvoiceTable(props) {
  const [data, setData] = useState([]);
  const [showdetails, setShowDetails] = useState(false);
  const [showedit, setShowEdit] = useState(false);
  const [showprint, setShowPrint] = useState(false);

  const [showStatusPrompt, setShowStatusPrompt] = useState(false);
  const [newStatus, setNewStatus] = useState("");
  const [invoice, setInvoice] = useState("");

  const [selectedRow, setSelectedRow] = useState(null);
  const [searchQuery, setSearchQuery] = useState("");
  const [loading, setLoading] = useState(true);
  const [message, setMessage] = useState(null);

  const { user } = useContext(AuthContext);
  const authTokens = JSON.parse(localStorage.getItem("authTokens"));

  const handleshowDetails = () => setShowDetails(true);
  const handlecloseDetails = () => setShowDetails(false);
  const handleshowPrint = () => setShowPrint(true);
  const handleclosePrint = () => setShowPrint(false);
  const handleshowEdit = () => setShowEdit(true);
  const handlecloseEdit = () => setShowEdit(false);
  const [dealerDetails, setDealerDetails] = useState({
    order_id: 0,
    invoice_id: 0,
  });

  const updateDealerDetails = (details) => {
    setDealerDetails(details);
  };

  const [filters, setFilters] = useState({
    description: "",
    date: "",
  });
  const [showFilterModal, setShowFilterModal] = useState(false);
  const [gridFilterModel, setGridFilterModel] = useState({
    items: [],
  });
  const [searchInput, setSearchInput] = useState(""); // To capture search input

  // NEW: State to track column visibility
  const [columnVisibilityModel, setColumnVisibilityModel] = useState({});
  const [searchFilterTimeout, setSearchFilterTimeout] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${API_URL}/inventory/drawer/daily/info/`,
          {
            headers: {
              Authorization: `Bearer ${authTokens.access}`,
            },
            params: {
              username: user.username,
              daily_drawer_id: props.daily_drawer_id,
              action: "Payment",
            },
          }
        );

        if (response.status === 200) {
          setData(response.data.reverse());
          console.log(response.data);
        }
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [user.username, authTokens.access]);

  const columns = [
    { field: "description", headerName: "Description", flex: 2, minWidth: 350 },
    {
      field: "date",
      headerName: "Date",
      flex: 2,
      minWidth: 230,
      sortable: true, // ensures it's sortable
      sort: "desc", // default descending sort
      valueFormatter: (params) => {
        const date = new Date(params.value);
        date.setHours(date.getHours() + 2);
        return formatDateTime(date);
      },
    },

    /*{
      field: "actions",
      headerName: "Actions",
      minWidth: 200,
      flex: 2,
      renderCell: (params) => (
        <div>
          <button
            className="edit-client"
            onClick={() => {
              const details = {
                order_id: params.row.order_id,
                invoice_id: params.row.invoice_id,
              };
              updateDealerDetails(details);
              handleshowEdit();
            }}
          >
            Edit
          </button>
          <button
            className="edit-client"
            onClick={() => {
              const details = {
                order_id: params.row.order_id,
                invoice_id: params.row.invoice_id,
              };
              updateDealerDetails(details);
              handleshowPrint();
            }}
          >
            Print
          </button>
        </div>
      ),
    },*/
  ];

  const showMessage = (message, type = "success") => {
    setMessage({ text: message, type });

    // Clear the message after 5 seconds
    setTimeout(() => {
      setMessage(null);
    }, 5000);
  };

  const getRowId = (row) => row.payment_id;

  // Create a delayed search filter function
  const delaySearchFilter = (input) => {
    setSearchQuery(input);
  };

  useEffect(() => {
    // Save "searchValue" value before clearing other session storage items
    const searchValue = sessionStorage.getItem("searchDrawerInvoice");

    // Clear all session storage items except "searchValue"
    Object.keys(sessionStorage).forEach((key) => {
      if (key !== "searchDrawerInvoice") {
        sessionStorage.removeItem(key);
      }
    });

    // Restore "searchValue" value if needed
    if (searchValue) {
      sessionStorage.setItem("searchDrawerInvoice", searchValue);
      setSearchQuery(searchValue);
    }
  }, []);

  const handleSearchChange = (event) => {
    const query = event.target.value;
    setSearchInput(query);
    sessionStorage.setItem("searchDrawerInvoice", query);

    if (searchFilterTimeout) {
      clearTimeout(searchFilterTimeout);
    }

    const newTimeout = setTimeout(() => {
      delaySearchFilter(query);
    }, 300);
    setSearchFilterTimeout(newTimeout);
  };

  // IMPROVED: Combined filtering logic that works for both display AND export
  const filteredRows = data.filter((row) => {
    // Apply search query filter
    const searchMatch = searchQuery
      .split(" ")
      .every((word) =>
        Object.values(row).some((value) =>
          String(value).toLowerCase().includes(word.toLowerCase().trim())
        )
      );

    // Apply modal filters
    const modalFilterMatch = Object.keys(filters).every((key) => {
      if (!filters[key]) return true;

      const rowValue = String(row[key] || "").toLowerCase();
      const filterValue = String(filters[key]).toLowerCase();
      return rowValue.includes(filterValue);
    });

    // Apply DataGrid filters
    const gridFilterMatch = gridFilterModel.items.every((filterItem) => {
      if (!filterItem.value) return true;

      const cellValue = row[filterItem.field];
      const filterValue = filterItem.value;

      switch (filterItem.operator) {
        case "contains":
          return String(cellValue || "")
            .toLowerCase()
            .includes(String(filterValue).toLowerCase());
        case "equals":
          return String(cellValue || "") === String(filterValue);
        case "startsWith":
          return String(cellValue || "")
            .toLowerCase()
            .startsWith(String(filterValue).toLowerCase());
        case "endsWith":
          return String(cellValue || "")
            .toLowerCase()
            .endsWith(String(filterValue).toLowerCase());
        default:
          return true;
      }
    });

    return searchMatch && modalFilterMatch && gridFilterMatch;
  });

  const handleFilterChange = (field, value) => {
    setFilters((prevFilters) => ({
      ...prevFilters,
      [field]: value,
    }));
  };

  const columnHeaders = {
    description: "Description",
    date: "Date",
  };

  // Format date fields for export as DD/MM/YY hh:mm AM/PM
  const formatDateForExport = (dateValue) => formatDateTime(dateValue);

  // Corrected: Transform rows respecting column visibility
  const transformRowsForExport = (rows) => {
    return rows.map((row) => {
      const transformedRow = {};

      Object.keys(columnHeaders).forEach((field) => {
        // Only export if column is visible
        if (columnVisibilityModel[field] !== false) {
          const headerName = columnHeaders[field];

          // Only date needs formatting
          if (field === "date") {
            transformedRow[headerName] = formatDateForExport(row[field]);
          } else {
            // Default: use the value or empty string
            transformedRow[headerName] = row[field] ?? "";
          }
        }
      });

      return transformedRow;
    });
  };

  // IMPROVED: Export function that uses the already-filtered rows
  const handleExportToExcel = () => {
    console.log("Exporting data...");
    console.log("Total data rows:", data.length);
    console.log("Filtered rows:", filteredRows.length);
    console.log("Active filters:", {
      search: searchQuery,
      modalFilters: filters,
      gridFilters: gridFilterModel.items,
    });
    console.log("Column visibility:", columnVisibilityModel);

    // Always use filteredRows which has ALL filters applied
    const transformedRows = transformRowsForExport(filteredRows);

    console.log("Rows to export:", transformedRows.length);

    const worksheet = XLSX.utils.json_to_sheet(transformedRows);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "DrawerInvoices");
    XLSX.writeFile(workbook, "DrawerInvoices.xlsx");
  };

  const [isPressed, setIsPressed] = useState(false);

  const handleExportClick = () => {
    setIsPressed(true);
    handleExportToExcel();
    setTimeout(() => {
      setIsPressed(false);
    }, 200);
  };

  const handleStatusCellClick = (params) => {
    if (params.row.status === "Pending") {
      setNewStatus("Done");
      setSelectedRow(params.row);
      setInvoice(params.row.invoice_id); // Set the invoice ID when the status cell is clicked
      setShowStatusPrompt(true);
    } else {
      setNewStatus(params.row.status || "Done"); // Set default value if status is not present
      setShowStatusPrompt(true);
      setSelectedRow(params.row);
      setInvoice(params.row.invoice_id); // Set the invoice ID when the status cell is clicked
    }
  };

  const handleStatusPromptClose = () => {
    setNewStatus("");
    setShowStatusPrompt(false);
    setSelectedRow(null);
  };

  const handleSubmit = async () => {
    try {
      const response = await axios.post(
        `${API_URL}/inventory/invoices/status/`,
        {
          status: newStatus,
          invoice: invoice,
          userdealer: user.username,
        },
        {
          headers: {
            Authorization: `Bearer ${authTokens.access}`,
          },
        }
      );

      console.log(response);
      showMessage("Status changed!", "success");
      // Fetch updated data
      const updatedData = await axios.get(`${API_URL}/inventory/invoices/`, {
        headers: {
          Authorization: `Bearer ${authTokens.access}`,
        },
        params: {
          username: user.username,
        },
      });
      setData(updatedData.data.reverse());
    } catch (error) {
      console.log(error);
      showMessage("Edit failed!", "danger");
    }
  };

  const handleStatusConfirmation = () => {
    console.log("Invoice ID:", selectedRow.invoice_id);
    console.log("New Status:", newStatus);
    // Perform any additional actions here (e.g., API call, state update)
    handleSubmit();
    handleStatusPromptClose();
  };

  const CustomToolbar = () => (
    <GridToolbarContainer>
      <GridToolbarColumnsButton />
      <Button
        onClick={() => setShowFilterModal(true)}
        style={{
          display: "flex",
          alignItems: "center",
          padding: "5px 10px",
          fontSize: "14px",
          color: "#0663FF",
          cursor: "pointer",
          marginLeft: "8px",
        }}
      >
        <img
          src={FilterSVG}
          alt="Filter Icon"
          style={{
            color: "white",
            width: "18px",
            marginRight: "8px",
            filter: "invert(0)", // keep black icon
          }}
        />
        Filter
      </Button>
      {/*<GridToolbarFilterButton />*/}
      <GridToolbarExport />
      <Button
        onClick={handleExportClick}
        variant="outline-success"
        style={{
          display: "flex",
          alignItems: "center",
          padding: "5px 10px",
          fontSize: "14px",
          border: "none",
          backgroundColor: isPressed ? "white" : "transparent",
          color: isPressed ? "black" : "#007bff",
          cursor: "pointer",
        }}
      >
        <img
          src={ExcelSVG}
          alt="Excel Icon"
          style={{
            width: "20px",
            marginRight: "8px",
            filter: isPressed ? "invert(0)" : "invert(1)",
          }}
        />
        Excel
      </Button>
    </GridToolbarContainer>
  );

  return (
    <div className="ClientTable">
      <style>{`
        .MuiDataGrid-panelWrapper {
          background: #122632 !important;
        }
      `}</style>
      <input
        type="text"
        placeholder="Search..."
        value={searchInput}
        onChange={handleSearchChange}
        className="search-client"
      />
      {!loading && data.length > 0 && (
        <div style={{ height: 520, width: "100%" }}>
          <DataGrid
            rows={filteredRows}
            columns={columns}
            getRowId={getRowId}
            filterModel={gridFilterModel}
            onFilterModelChange={(newModel) => setGridFilterModel(newModel)}
            columnVisibilityModel={columnVisibilityModel}
            onColumnVisibilityModelChange={(newModel) =>
              setColumnVisibilityModel(newModel)
            }
            components={{
              Toolbar: CustomToolbar,
            }}
            rowsPerPageOptions={[10, 100, 1000]}
            pagination
            disableSelectionOnClick
          />
        </div>
      )}
      <Modal show={showedit} onHide={handlecloseEdit} className="modal-lg">
        <Modal.Header closeButton>
          <Modal.Title>Edit</Modal.Title>
        </Modal.Header>
        <EditInvoice
          invoice_id={dealerDetails.invoice_id}
          order_id={dealerDetails.order_id}
        />
      </Modal>
      <Modal show={showprint} onHide={handleclosePrint} className="modal-lg">
        <Modal.Header closeButton>
          <Modal.Title>Print</Modal.Title>
        </Modal.Header>
        <PrintInvoice
          invoice_id={dealerDetails.invoice_id}
          order_id={dealerDetails.order_id}
          data={data.filter(
            (item) => item.invoice_id === dealerDetails.invoice_id
          )}
          data1={data}
        />
      </Modal>
      <Modal show={showStatusPrompt} onHide={handleStatusPromptClose}>
        <Modal.Header closeButton>
          <Modal.Title>Change Status</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <label htmlFor="newStatus">Select new status:</label>
          <select
            id="newStatus"
            value={newStatus}
            onChange={(e) => setNewStatus(e.target.value)}
            className="form-select"
          >
            <option value="Done">Done</option>
            <option value="Blocked">Blocked</option>
          </select>
        </Modal.Body>
        <Modal.Footer>
          <button
            className="btn btn-secondary"
            onClick={handleStatusPromptClose}
          >
            Cancel
          </button>
          <button
            className="btn btn-primary"
            onClick={handleStatusConfirmation}
          >
            Confirm
          </button>
        </Modal.Footer>
      </Modal>
      <Modal show={showFilterModal} onHide={() => setShowFilterModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Filters</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {columns
            .filter((col) => col.field !== "actions")
            .map((col) => (
              <div key={col.field} className="filter">
                <label>{col.headerName}</label>
                <input
                  type="text"
                  placeholder={`Filter by ${col.headerName}`}
                  value={filters[col.field] || ""}
                  onChange={(e) =>
                    handleFilterChange(col.field, e.target.value)
                  }
                  className="filter-input"
                />
              </div>
            ))}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowFilterModal(false)}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
      {message && (
        <div
          className={`alert alert-${message.type} alert-dismissible fade show`}
          role="alert"
          style={{
            position: "fixed",
            bottom: "10px",
            margin: "10px",
            right: "10px",
            zIndex: "9999",
          }}
        >
          {message.text}
        </div>
      )}
    </div>
  );
}

export default InvoiceTable;
